import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ListToggleComponent } from '@zero/shared/ui-web-design-system';
import { Customer } from '@zero/shared/util-models';
import { AuthService, DataService } from '@zero/shared/util-web-app-services';
import { commonRoutes } from 'constants/web-app-constants';
import { environment } from 'environments/environment';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CanceledOrdersComponent } from '../canceled-orders/canceled-orders.component';
import { ExecutedOrdersComponent } from '../executed-orders/executed-orders.component';
import { OpenOrdersComponent } from '../open-orders/open-orders.component';

@Component({
  selector: 'order-zero-orders',
  templateUrl: './orders.component.html',
  imports: [ListToggleComponent, OpenOrdersComponent, ExecutedOrdersComponent, CanceledOrdersComponent],
})
export class OrdersComponent implements OnInit {
  @Input() public actionsEnabled = true;

  @Output() public reloadPositions = new EventEmitter<void>();

  public showOrders = true;
  public readonly commonRoutes = commonRoutes;
  public readonly environment = environment;
  public orderSelector: 'open' | 'executed' | 'canceled' = 'open';
  public currentCustomer: Customer;
  public isPotentialCustomer = true;

  readonly #rootData = inject(DataService);
  readonly #authService = inject(AuthService);
  readonly #destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    combineLatest([this.#rootData.selectedCustomerChanged.pipe(filter((newCust) => !!newCust)), this.#authService.isCustomer$()])
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((value) => {
        if (value[1]) {
          this.loadCustomer();
        }
      });
    this.#authService
      .isPotentialCustomer()
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((isPotentialCustomer) => {
        this.isPotentialCustomer = isPotentialCustomer;
      });
  }

  public loadCustomer(): void {
    this.currentCustomer = this.#rootData.getSelectedCustomerItem();
  }
}
